
// Development Firebase Configuration
const firebaseConfig = {
    projectId: "the-pool-app-dev",
    appId: "1:916133447002:web:c91d292c28d7cb38ce9f63",
    storageBucket: "the-pool-app-dev.firebasestorage.app",
    apiKey: "AIzaSyCUVYC2FD0vpne--4jxGgILhZEhi2zw7So",
    authDomain: "the-pool-app-dev.firebaseapp.com",
    messagingSenderId: "916133447002",
    measurementId: "G-5ZS2M2TCZ3"
};

export default firebaseConfig;
